import { render, staticRenderFns } from "./GStudentEdit.vue?vue&type=template&id=39cd8d76&scoped=true&"
import script from "./GStudentEdit.vue?vue&type=script&lang=ts&"
export * from "./GStudentEdit.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentEdit.vue?vue&type=style&index=0&id=39cd8d76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cd8d76",
  null
  
)

export default component.exports